import { RolaUzytkownika, Produkt } from "./organizacje";

export interface UzytkownikWidok {
  IdZaproszenia: string;
  IdKonta: string;
  Imie: string;
  Nazwisko: string;
  Email: string;
  Rola: RolaUzytkownika;
  Status: StatusUzytkownika;
}

export interface Uzytkownik {
  IdZaproszenia: string;
  IdKonta: string;
  Email: string;
  Rola: RolaUzytkownika;
  Produkty: Produkt[];
  Wiadomosc: string;
}

export enum StatusUzytkownika {
  Niepotwierdzono = "Niepotwierdzono",
  Potwierdzono = "Potwierdzono",
  Odrzucono = "Odrzucono"
}

export const uzytkownicyConsts = {
  UZYTKOWNICY_PRZEGLADAJ_REQUEST: "UZYTKOWNICY_PRZEGLADAJ_REQUEST",
  UZYTKOWNICY_PRZEGLADAJ_SUCCESS: "UZYTKOWNICY_PRZEGLADAJ_SUCCESS",
  UZYTKOWNICY_PRZEGLADAJ_FAILURE: "UZYTKOWNICY_PRZEGLADAJ_FAILURE",

  UZYTKOWNICY_ZAPROS_REQUEST: "UZYTKOWNICY_ZAPROS_REQUEST",
  UZYTKOWNICY_ZAPROS_SUCCESS: "UZYTKOWNICY_ZAPROS_SUCCESS",
  UZYTKOWNICY_ZAPROS_FAILURE: "UZYTKOWNICY_ZAPROS_FAILURE",

  UZYTKOWNICY_ZAPROS_PONOWNIE_REQUEST: "UZYTKOWNICY_ZAPROS_PONOWNIE_REQUEST",
  UZYTKOWNICY_ZAPROS_PONOWNIE_SUCCESS: "UZYTKOWNICY_ZAPROS_PONOWNIE_SUCCESS",
  UZYTKOWNICY_ZAPROS_PONOWNIE_FAILURE: "UZYTKOWNICY_ZAPROS_PONOWNIE_FAILURE",

  UZYTKOWNICY_DAJ_REQUEST: "UZYTKOWNICY_DAJ_REQUEST",
  UZYTKOWNICY_DAJ_SUCCESS: "UZYTKOWNICY_DAJ_SUCCESS",
  UZYTKOWNICY_DAJ_FAILURE: "UZYTKOWNICY_DAJ_FAILURE",

  UZYTKOWNICY_USUN_REQUEST: "UZYTKOWNICY_USUN_REQUEST",
  UZYTKOWNICY_USUN_SUCCESS: "UZYTKOWNICY_USUN_SUCCESS",
  UZYTKOWNICY_USUN_FAILURE: "UZYTKOWNICY_USUN_FAILURE",

  UZYTKOWNICY_EDYTUJ_REQUEST: "UZYTKOWNICY_EDYTUJ_REQUEST",
  UZYTKOWNICY_EDYTUJ_SUCCESS: "UZYTKOWNICY_EDYTUJ_SUCCESS",
  UZYTKOWNICY_EDYTUJ_FAILURE: "UZYTKOWNICY_EDYTUJ_FAILURE",

  CLEAR_BROWSE_ERROR: "CLEAR_BROWSE_ERROR",
  CLEAR_EDIT_ERROR: "CLEAR_EDIT_ERROR"
};

export interface UzytkownicyAction {
  type: string;
  lista: UzytkownikWidok[];
  error: string;
}
